/**
 * client-server processing
 * WEB APIへリクエストしてレスポンスを取得する
 * 200,201 ->Resolve:取得データをそのまま返す
 * 400,404,500,タイムアウト
 *    -> Reject: 所定のエラーメッセージをエラーのコールバックへ渡す
 *
 */
import VueOnsen from 'vue-onsenui'
import Axios from 'axios'
import setting from '../ms.config'
//import mock from './mock'
//import errors from './errors'
import labelJa from '../localize/ja.json'
import labelEn from '../localize/en.json'
import labelKo from '../localize/ch.json'
import { disableDeviceBackButtonHandler } from 'onsenui'
/*
const $http = Axios.create({
  // for cors
  withCredentials: true
})
*/


function localizeError(keyName, lang) {
  let language
  try {
    switch (lang) {
      case 'ja':
        language = labelJa
        break
      case 'en':
        language = labelEn
        break
      case 'ko':
        language = labelKo
        break
      default:
    }
    return language.pages['ErrorMessage'].labels[keyName]
  } catch (e) {
    // console.log('in localizeLabel: matched key not exist')
  }
}

export default {
  // axios でサーバーへPOST（MSではメソッドはPOSTのみ）
  request(uri, param) {
    return new Promise((resolve, reject) => {
      // call api
      
      const CancelToken = Axios.CancelToken;
      let cancel;
      
      var root_uri =''
      /*
      if(setting.ENV.mode=='product'){
        root_uri = setting.HOST['product']+setting.ENV.BASE_URL
      }else{
        root_uri = setting.HOST['dev']+setting.ENV.BASE_URL
      }
      */
      //ローカルの場合はdevへ接続
      if(location.host.match(/localhost/)){
        root_uri = setting.HOST['dev']+setting.ENV.BASE_URL
      }else{
        root_uri = location.protocol+'//'+ location.host+setting.ENV.BASE_URL
      }
      

      function success(result){
        // console.log('uri posted:' + uri + ' ,result=' + result)
        const response = JSON.parse(result.request.response)
        if (response.status != true) {
          // エラーあり
          // 認証エラーの場合はログインページへ飛ばす
          // 入力エラーの場合は画面へ表示
          // それ以外はエラーアラート表示
          reject(response.result_data)
          
        } else {
          if (response.result_data) {
            resolve(response.result_data)
          } else {
            // 例外エラー
            VueOnsen.notification.alert(
              'Server Result Data Format incorrect',
              setting.dialog.optionError
            )
            reject(response)
          }
        }
      }

      if (cancel) {
        console.log("Cancel!!!");
        cancel();
      }
      console.log('root_uri:'+root_uri)
      console.log('uri:'+uri)
      Axios.post(
        root_uri+uri,         
        param, {
        timeout: setting.ENV.REQUEST_TIMEOUT*10,
      })
        .then(success)      
        .catch(error => {
          if (!error.response) {
            if ( error.message.indexOf('Network Error') != -1) {
              // 物理回線エラーの場合は１回りトライ
              reject('ネットワークに問題があります。<br>しばらくして再度実行してください。')
            }else{
              reject('サーバー通信時に問題が発生しました。<br>しばらくして再度実行してください。')
            }
            
          }
          // console.error(error.response)
          if (error.response.data.errors) {
            
            reject(error.response.data.errors)
            
          } else {
            // システムエラー時の処理
            VueOnsen.notification.alert(
              error.response.statusText,
              setting.dialog.optionError
            )
            reject(error.response.statusText)
          }
        })
      
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/webapi.js